import { getHookRunners } from "./hooks";
var compatPlugin = function() {
  return {
    name: "@modern-js/runtime-plugin-compat",
    _registryApi: function(getRuntimeContext) {
      return {
        useRuntimeConfigContext: function() {
          var _internalContext = getRuntimeContext()._internalContext;
          return _internalContext.config;
        },
        useHookRunners: function() {
          return getHookRunners(getRuntimeContext());
        }
      };
    }
  };
};
export {
  compatPlugin
};
